<ion-list lines="none">
  @for (language of availableLanguages; track language) {
    <ion-item button
              class="ion-text-center"
              (click)="changeLanguage(language)">
      <span [class.bold]="currentLanguage === language">
        {{ 'languages.' + language | translate }}
      </span>
    </ion-item>
  }
</ion-list>